import { getFirestore, query, collection, where, getDocs } from 'firebase/firestore'
import { useAppStore } from '@/stores/appdata'

const db = getFirestore()

// Cache de l'id du document appdata par application : évite une requête Firestore
// supplémentaire avant CHAQUE lecture/écriture.
const appdataIdCache = {}

async function resolveAppdataId(appId) {
  let documentsQuery = query(collection(db, "/appdata"), where("application", "==", appId))
  let response = await getDocs(documentsQuery)

  if (response.empty) {
    throw new Error(`Aucun document appdata trouvé pour l'application ${appId}`)
  }
  if (response.size > 1) {
    console.warn(`[getCollectionPath] ${response.size} documents appdata pour l'application ${appId}`)
  }

  // Même document que celui conservé par Appdata.listenByApplication (le premier)
  return response.docs[0].id
}

let getCollectionPath = async (collectionName) => {
  const appStore = useAppStore()
  const appId = appStore.app.id

  if (!appdataIdCache[appId]) {
    appdataIdCache[appId] = resolveAppdataId(appId).catch(error => {
      delete appdataIdCache[appId]
      throw error
    })
  }

  const appdataId = await appdataIdCache[appId]
  return `appdata/${appdataId}/${collectionName}`
}

export default getCollectionPath
